module.exports = __webpack_public_path__ + "static/media/video.dd3a53cf.mp4";